import React from 'react';
import './Admin.css';

const AdminDashboardPage = () => {
  return (
    <div className="admin-dashboard">
      <h1>Admin Dashboard - Add Job</h1>
      <div className="admin-box">
        <h2>General Information</h2>
        <form>
          <label>Job Title</label>
          <input type="text" placeholder="Job Title" />

          <label>Company Name</label>
          <input type="text" placeholder="Company Name" />

          <label>Category</label>
          <input type="text" placeholder="Category" />

          <label>Description</label>
          <textarea placeholder="Description"></textarea>

          <label>Salary Range</label>
          <input type="text" placeholder="Salary Range" />

          <label>No. Of Vacancy</label>
          <input type="number" placeholder="No. Of Vacancy" />

          <label>Experience</label>
          <input type="text" placeholder="Experience" />

          <label>Company Logo</label>
          <input type="file" />

          <label>Job Type</label>
          <input type="text" placeholder="Job Type" />

          <label>Qualification Required</label>
          <input type="text" placeholder="Qualification" />

          <label>Skills (Separate with Comma)</label>
          <input type="text" placeholder="Skills" />
        </form>
      </div>

      <div className="admin-box">
        <h2>Company Address</h2>
        <form>
          <label>Email</label>
          <input type="email" placeholder="Email" />

          <label>Phone Number</label>
          <input type="tel" placeholder="Phone Number" />

          <label>Website Link</label>
          <input type="url" placeholder="Website Link" />

          <label>Address</label>
          <input type="text" placeholder="Address" />

          <label>City</label>
          <input type="text" placeholder="City" />

          <label>State</label>
          <input type="text" placeholder="State" />

          <label>Country</label>
          <input type="text" placeholder="Country" />

          <label>Zip Code</label>
          <input type="text" placeholder="Zip Code" />
        </form>
      </div>

      <div className="submit-box">
        <button type="submit">Submit</button>
      </div>
    </div>
  );
};

export default AdminDashboardPage;
